import { endPoint } from "./base.config";

export const inbox = {
  computeData: `${endPoint}inbox/computeData`,
  readById: `${endPoint}inbox/readById/:id`,
}